module.exports = __webpack_public_path__ + "static/devopsdday2019-138f74c83845bdcc1c85001ffa3cbaba.png";